import { DeviceProperties, EcsDevice } from 'shared/models';
import { DeviceClassIcon } from 'ui/setup/deviceClassIcon/DeviceClassIcon';
import { useDeviceTypes } from 'hooks/useDeviceTypes/useDeviceTypes';
import { LoadingSpinner } from 'ui/shared/LoadingSpinner';
import { useTranslation } from 'react-i18next';
import { expandMacAddress } from 'util/cleanMacAddress';

require('./ElevatorDevice.css');

export type Props = {
    device: EcsDevice;
};

type CameraDeviceProperties = DeviceProperties & {
    fps: number;
    width: number;
    height: number;
    rotation: number;
    compression: number;
    firmwareVersion: string;
    validRotations: string;
    validResolutions: string;
    groupId: string;
    // ...
};

export const ElevatorDevice = ({ device }: Props) => {
    const { t } = useTranslation();
    const { deviceTypes, isLoadingDeviceTypes } = useDeviceTypes();

    const deviceTypeId = device ? device.deviceTypeId : '';
    const deviceType = (deviceTypeId && deviceTypes && deviceTypes[deviceTypeId]) || null;

    const {
        firmwareVersion,
        width,
        height,
        fps,
    } = device.properties as CameraDeviceProperties;

    return (
        <div
            className="elevator-device"
            id={ `elevator-device-${device.deviceId}` }
        >
            <div className="elevator-device-icon">
                <DeviceClassIcon
                    size="small"
                    deviceClass={ device.deviceClass }
                />
            </div>
            <div className="elevator-device-details">
                <div className="elevator-device-model">
                    <span>
                        { deviceType ? deviceType.displayName : '...' }
                    </span>
                    { isLoadingDeviceTypes && !deviceType &&
                        <LoadingSpinner size="tiny"/>
                    }
                </div>
                <div className="elevator-device-mac">
                    <span className="label">
                        { t('ELEVATOR.LABEL.ADDRESS') }
                    </span>
                    <span>
                        { expandMacAddress(device.macAddress) }
                    </span>
                </div>
                { firmwareVersion &&
                    <div className="elevator-device-firmware">
                        <span className="label">
                            { t('ELEVATOR.LABEL.FIRMWARE') }
                        </span>
                        <span>
                            { firmwareVersion }
                        </span>
                    </div>
                }
                { width && height &&
                    <div className="elevator-device-resolution">
                        <span className="label">
                            { t('ELEVATOR.LABEL.RESOLUTION') }
                        </span>
                        <span>
                            { fps
                                ? `${width}x${height} @ ${fps} FPS`
                                : `${width}x${height}`
                            }
                        </span>
                    </div>
                }
            </div>
        </div>
    );
};
